import { Login } from '../../api/login'

// import firebase from 'firebase/app'
// import 'firebase/auth'
import axios from '../../axios'
import router from '@/router'

const LoginStorage = {
  state: {
    user_details: {
      user:  localStorage.getItem('userInfo') || null,
      access_token: localStorage.getItem('access_token') || null,
      customer_id: localStorage.getItem('customer_id') || null,
      customer_name: localStorage.getItem('customer_name') || null
    }
  },
  mutations: {
    UPDATE_USER_INFO: (state, user) => {
      state.user_details.user = user
    },
    UPDATE_ACCESS_TOKEN: (state, access_token) => {
      state.user_details.access_token = access_token
    },
    SET_BEARER: (access_token) => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
    },
    SET_CUSTOMERID: (state, customer_id) => {
      state.user_details.customer_id = customer_id
    },
    SET_CUSTOMERNAME: (state, customer_name) => {
      state.user_details.customer_name = customer_name
    }
  },
  actions: {
    loginJWT ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Login(payload.userDetails)
          .then(data => {
            console.log('loginJWT store.js')
            resolve(data)
            
          }).catch(error => {
            console.log('LoginStore.js error = ', error)
            reject(error)
          })
      })
    },
    GoogleSSO ({ commit }, payload) {
      localStorage.setItem('access_token', JSON.stringify(payload.access_token))
      localStorage.setItem('userInfo', JSON.stringify(payload.user))

      commit('UPDATE_USER_INFO', payload.user)
      commit('UPDATE_ACCESS_TOKEN', payload.access_token)
      commit('SET_BEARER', payload.access_token)
    },
    Logout ({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit('UPDATE_USER_INFO', '')
          commit('UPDATE_ACCESS_TOKEN', '')
          commit('SET_CUSTOMERID', '')
          commit('SET_CUSTOMERNAME', '')
          localStorage.removeItem('access_token')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('customer_id')
          localStorage.removeItem('customer_name')
          resolve('Logged out successfully')
        } catch (e) {
          reject(e)
        }
      })
    },
    setCustomerId ({ commit }, customerId) {
      return new Promise((reslove, reject) => {
        try {
          localStorage.setItem('customer_id', JSON.stringify(customerId))
          commit('SET_CUSTOMERID', JSON.stringify(customerId))
        } catch (e) {
          reject(e)
        }
      })
    },
    setCustomerName ({commit}, customerName) {
      return new Promise((reslove, reject) => {
        try {
          localStorage.setItem('customer_name', JSON.stringify(customerName))
          commit('SET_CUSTOMERNAME', customerName)
        } catch (e) {
          reject(e)
        }
      })
    }
  },
  getters: {
    token (state) {
      return state.user_details.access_token
    },
    customerId: (state) => {
      return state.user_details.customer_id
    },
    customerName: (state) => {
      return state.user_details.customer_name
    },
    isUserLoggedIn: (state) => {
      let isAuthenticated = false
      const user  = state.user_details.userInfo
      const access_token  = state.user_details.access_token
      // get firebase current user
      // const firebaseCurrentUser = firebase.auth().currentUser
      if ((!user || user === '') && (!access_token || access_token === '')) {
        isAuthenticated =  false
      } else {
        isAuthenticated = true
      }
      return isAuthenticated

      // if (auth.isAuthenticated() || firebaseCurrentUser) isAuthenticated = true
      // else isAuthenticated = false

      // return localStorage.getItem('userInfo') && isAuthenticated
    }
  }
}
export default LoginStorage
